import { Dropdown, Typography } from '@hmsexp/component-library';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { View } from '../../../../../components/Common/react-native-components';
import { dropdownStyling, additionalMetrixStyling } from './style';
import { get } from 'lodash';
import { useTransformAdditionalMetrixComparisonChartData } from '../../../hooks/useTransformAdditionalMetrixComparisonChartData';
import { ADDITIONAL_METRIX_OPTIONS } from '../../../constants';
import GenericNoData from '../../../../../components/Common/NoData/GenricNoData';
import { handleHighChartsExport } from '../../../utils';

const AdditionalMetrixComparison = forwardRef((props, ref) => {
  const { options, data, isnoData, widgetData } = props;

  const [selectedMetrix, setSelectedMetrix] = useState('percentage');

  const selectedMetrixLabel = ADDITIONAL_METRIX_OPTIONS?.find(e => e.value === selectedMetrix)?.label;
  const styles = additionalMetrixStyling();
  const chartOptions = useTransformAdditionalMetrixComparisonChartData(
    options,
    selectedMetrix,
    data,
    selectedMetrixLabel
  );
  const color = get(options, 'series[0].color');

  const chartRef = useRef(null);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, widgetData);
  };

  useImperativeHandle(ref, () => ({ actionButtonClick }));

  if (isnoData) {
    return <GenericNoData />;
  }

  return (
    <View>
      <Typography
        textProps={{ style: { marginBottom: 5 } }}
        variant='button'
        color='primaryContentMedium'
        fontWeightType='regular'>
        Calculation
      </Typography>

      <View style={{ maxWidth: 200 }}>
        <Dropdown
          items={ADDITIONAL_METRIX_OPTIONS}
          onChange={setSelectedMetrix}
          value={selectedMetrix}
          label={''}
          style={{
            container: {
              ...dropdownStyling.container
            },
            optionContainer: dropdownStyling.optionContainer,
            dropDownText: dropdownStyling.dropDownText,
            icon: dropdownStyling.icon
          }}
        />
      </View>
      <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} />
      <View style={{ flexDirection: 'row' }}>
        <View style={[styles.selectedMetrixContainer, { borderColor: color }]}>
          <View style={{ width: 10, height: 10, backgroundColor: color }}></View>
          <Typography fontWeightType='regular' variant='button'>
            {selectedMetrixLabel}
          </Typography>
        </View>
      </View>
    </View>
  );
});
export default AdditionalMetrixComparison;
